import {json, type LoaderArgs} from '@shopify/remix-oxygen';
import {useLoaderData} from '@remix-run/react';
import type {Blog} from '@shopify/hydrogen/storefront-api-types';
import {Link} from '~/components';
import {CACHE_SHORT, routeHeaders} from '~/data/cache';
import {
  aggregateFields,
  findFieldsNode,
  getReferenceNodes,
  getSiteDetails,
  processArticle,
} from '~/utils';
import PageBanner from '~/components/Common/PageBanner';
import * as Icon from 'react-feather';
import NavbarSection from '~/components/Sections/NavbarSection';
import {useGetContext} from '~/hooks/useGetContext';
import {fetchSite} from '~/lib/storefrontFetcher';
const BLOG_HANDLE = 'Blog';

export const headers = routeHeaders;

export const loader = async ({request, context}: LoaderArgs) => {
  const {storefront} = context;
  const {language, country} = storefront.i18n;
  const site = await fetchSite({context});
  const {articles} = await getSiteDetails(context, site);

  const seo = {};

  return json(
    {articles, seo, language, country},
    {
      headers: {
        'Cache-Control': CACHE_SHORT,
      },
    },
  );
};

export default function Blog() {
  const {articles, language, country} = useLoaderData<typeof loader>();
  const {menuItems, logo, isAuthenticated} = useGetContext();
  return (
    <>
      <NavbarSection
        menuItems={menuItems}
        logo={logo || ''}
        title={'Blogs' || ''}
        isAuthenticated={isAuthenticated}
      />
      <PageBanner pageTitle="Blogs" />

      <div className="blog-area ptb-80">
        <div className="container">
          <div className="row justify-content-center">
            {articles?.map((article) => {
              const {id, title, media, content, author, handle, createdAt} =
                processArticle(article, language, country);

              return (
                <div className="col-lg-4 col-md-6" key={`${handle}-${id}`}>
                  <div className="single-blog-post">
                    <div className="blog-image">
                      <Link to={handle}>
                        <img src={media} alt={title} />
                      </Link>

                      <div className="date">
                        <Icon.Calendar />
                        {createdAt}
                      </div>
                    </div>

                    <div className="blog-post-content">
                      <h3>
                        <Link to={handle}>{title}</Link>
                      </h3>

                      <span>
                        By <Link to="/">{author}</Link>
                      </span>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: content,
                        }}
                        className="prose blog-card-content"
                      />

                      <Link to={handle} className="read-more-btn">
                        Read More <Icon.ArrowRight />
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
